import $ from 'jquery';

/* Accessbiltiy fixes */

$(document).ready(function() {
    // On focus, add the hide class
    $('.search-button-global.common-top-search-button').on('focus', function() {
        $(this).addClass('hide'); // Adds the hide class on focus
        $(this).parents('form').addClass('hide-after');
    });

    // On blur (when the focus is lost), remove the hide class
    $('.search-button-global.common-top-search-button').on('blur', function() {
        $(this).removeClass('hide'); // Removes the hide class on blur
    });

    // Initially set tabindex to -1
    $('.search-button-global.common-top-search-button').attr('tabindex', '-1');

    // Keyup event for handling input value and showing/hiding the button
    $('.search-button-global.common-top-search-button').on('keyup', function() {
        $(this).parents('form').removeClass('hide-after');
        const valueOfInput = $(this).parents('form').find('.archive_phrase_search.noeffect-input').val();
        let archiveSearchButtonCommon = $(this).parents('form').find('.search-button-global');
        
        if (valueOfInput && valueOfInput !== '') {
            $('.search-button-global.common-top-search-button').attr('tabindex', '0');
            archiveSearchButtonCommon.removeClass('hide');
        } else {
            archiveSearchButtonCommon.addClass('hide');
        }
    });

    // Handle keyboard events for accessibility
    $('.header-search-button').on('keydown', function(e) {        
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault(); 
            $(this).click(); 
        }
    });


$(".menu>li>a").addClass("menu-acc");
	$(".menu-acc").focus(function(e) {
		if($( ".menu-submenu" ).hasClass( "menu-open" )){
			$('.menu-submenu').removeClass("menu-open");
			$(".menu-arrow-down").attr("aria-expanded", "false");
		}
});


// Toggle submenu on click for the arrow button
$('.menu-arrow-down').on('click', function() {
    const submenu = $(this).next('.menu-submenu'); // Get the associated submenu
    const isExpanded = $(this).attr('aria-expanded') === 'true'; // Check if the menu is currently expanded

    // Toggle aria-expanded attributes
    $(this).attr('aria-expanded', !isExpanded); // Set aria-expanded for the button
    submenu.attr('aria-expanded', !isExpanded); // Set aria-expanded for the submenu

    // Toggle visibility of the submenu
    if (isExpanded) {                 
        submenu.removeClass('menu-open'); 
    } else {                
        submenu.addClass('menu-open'); 
    }
});



$('.mobile-nav-button').on('click', function() {
    var $button = $(this);     
    
    if ($button.hasClass('opened')) {        
        $button.attr('aria-label', 'close navigation');
       // $button.removeClass('opened'); 
    } else {
        
        $button.attr('aria-label', 'open navigation');
        $button.removeClass('opened'); 
    }
});






});


